/**
 * @file BenefitPlanHeaderDisplayTab.js
 * @description Tab component for managing benefit plan header text with rich text editing.
 */

import { useState, useEffect, useCallback, useRef } from 'react';
import RichTextEditor from '../../new-portal-page/RichTextEditor';
import styles from './../PlanYear.module.scss';
import { getText } from '../../../i18n';

const BenefitPlanHeaderDisplayTab = ({ data, onChange }) => {
    const [content, setContent] = useState(data.headerDisplay || '');
    const [initialContentSet, setInitialContentSet] = useState(false);
    const staticInitialContent = useRef(data.headerDisplay || '').current;

    useEffect(() => {
        if (!initialContentSet) {
            setContent(data.headerDisplay || '');
            setInitialContentSet(true);
        }
    }, [data.headerDisplay, initialContentSet]);

    useEffect(() => {
        if (initialContentSet && content !== (data.headerDisplay || '')) {
            onChange({ headerDisplay: content });
        }
    }, [content, onChange, data.headerDisplay, initialContentSet]);

    const handleContentUpdate = useCallback(input => {
        setContent(input);
    }, []);

    return (
        <div className="col-12 col-xs-12 col-md-12 col-lg-8 m-auto pb-5">
            <div className="form-group mb-3">
                <div className=" mb-5 pt-4">
                    <h5 className="">{getText('msg_d2ad8830a74c')}</h5>
                    <p className="text-muted">{getText('msg_b8af31e6650c')}</p>
                </div>
                <div className={styles.editorContainer}>
                    <RichTextEditor
                        initialContent={staticInitialContent}
                        onContentUpdate={handleContentUpdate}
                        disableHomeLink={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default BenefitPlanHeaderDisplayTab;
